import { User } from "./types";

// Must match backend/internal/flags/registry.go exactly.
export type FlagKey =
  | "portfolio_invites"
  | "public_api"
  | "ai_features"
  | "live_connections"
  | "portfolio_reports"
  | "founder_mcp";

// Flags arrive with the user, so there is never a pending state. A key the
// backend did not send resolves off.
export function isFlagEnabled(user: User | null, key: FlagKey): boolean {
  if (!user) return false;

  const flag = user.flags?.find((f) => f.key === key);
  if (!flag) {
    if (process.env.NODE_ENV === "development") {
      console.warn(`[flags] "${key}" is not in the resolved payload; treating it as off.`);
    }
    return false;
  }

  return flag.enabled;
}
